import React from "react";
import * as Icon from "react-feather";
const navigationConfig = [
  {
    id: "dashboard",
    title: "Dashboard",
    type: "item",
    icon: <Icon.Home size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/",
  },
  {
    type: "groupHeader",
    groupTitle: "APPS",
  },
  {
    id: "eCommerce",
    title: "Ecommerce",
    type: "collapse",
    icon: <Icon.ShoppingCart size={16} />,
    children: [
      {
        id: "ecommerce",
        title: "Overview",
        type: "item",
        icon: <Icon.Circle size={10} />,
        navLink: "/ecommerce/dashboard",
        permissions: ["admin", "editor"],
      },
      {
        id: "customers",
        title: "Customers",
        type: "item",
        icon: <Icon.Circle size={10} />,
        navLink: "/ecommerce/customers",
        permissions: ["admin", "editor"],
      },
      {
        id: "shops",
        title: "Shops",
        type: "item",
        icon: <Icon.Circle size={10} />,
        navLink: "/ecommerce/shops",
        permissions: ["admin", "editor"],
      },
      {
        id: "products",
        title: "Products",
        type: "item",
        icon: <Icon.Circle size={10} />,
        navLink: "/ecommerce/products",
        permissions: ["admin", "editor"],
      },
    ],
  },


  {
    id: "Ride",
    title: "Ride",
    type: "collapse",
    icon: <Icon.ShoppingCart size={16} />,
    children: [
      {
        id: "ride_overview",
        title: "Overview",
        type: "item",
        icon: <Icon.Circle size={10} />,
        navLink: "/ride/overview",
        permissions: ["admin", "editor"],
      },
      {
        id: "ride_operator",
        title: "Operator",
        type: "item",
        icon: <Icon.Circle size={10} />,
        navLink: "/ride/operators",
        permissions: ["admin", "editor"],
      },
      {
        id: "ride_driver",
        title: "Driver",
        type: "item",
        icon: <Icon.Circle size={10} />,
        navLink: "/ride/drivers",
        permissions: ["admin", "editor"],
      },
      
    ],
  },




  {
    type: "groupHeader",
    groupTitle: "Users",
  },
  {
    id: "users",
    title: "User",
    type: "collapse",
    icon: <Icon.User size={20} />,
    children: [
      {
        id: "list",
        title: "List",
        type: "item",
        icon: <Icon.Circle size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/user/list",
      },
      {
        id: "register",
        title: "Register",
        type: "item",
        icon: <Icon.Circle size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/user/register",
      },
      {
        id: "roles",
        title: "Roles",
        type: "item",
        icon: <Icon.Circle size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/user/role",
      },
    ],
  },
];

export default navigationConfig;
